define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/page",
	"csi/xml"
], function(declare,Controller,page,xml) {

	return declare(Controller, {
		toWriter: function() {
			// summary: update Material Managed and Status attribute
			this.m_writer.changeNode(this.m_urlNode).changeAttribute("Managed", xml.ATTR_BOOLEAN, !this.m_bToggle);
		},

		postProcessSuccess: function() {
			// summary: refresh all views to show sourcing tab among other things
			page.refreshViews();
		}
	});
});